<template>
  <v-alert
    v-model="showAlert"
    :color="alert.color"
    :icon="alert.icon"
    :style="{'z-index': 500, position: 'fixed', width: '100%'}"
    dismissible
  >
    {{ translation }}
  </v-alert>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    alert: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showAlert: true,
    };
  },
  computed: {
    translation() {
      return this.$t(this.alert.message);
    },
  },
  watch: {
    alert(newAlert) {
      if (newAlert) {
        this.showAlert = true;
      }
    },
  },
};
</script>
